var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    fill: "#1434CB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26608_76539",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 24,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3965 8.65589C15.3833 9.69395 16.3216 10.2733 17.0284 10.6177C17.7546 10.9711 17.9985 11.1977 17.9957 11.5137C17.9902 11.9973 17.4164 12.2108 16.8794 12.2191C15.9425 12.2336 15.3978 11.9662 14.9647 11.7638L14.6273 13.3431C15.0618 13.5433 15.8663 13.718 16.7006 13.7256C18.6589 13.7256 19.9402 12.7589 19.9471 11.26C19.9547 9.35786 17.316 9.25253 17.334 8.40227C17.3402 8.14449 17.5862 7.86938 18.1253 7.7994C18.3921 7.76405 19.1287 7.73703 19.9638 8.12162L20.2915 6.59365C19.8425 6.43011 19.2652 6.2735 18.5466 6.2735C16.7034 6.2735 15.4068 7.25334 15.3965 8.65589ZM23.441 6.40516C23.0835 6.40516 22.782 6.61374 22.6476 6.93389L19.8501 13.6133H21.807L22.1965 12.5372H24.5879L24.8138 13.6133H26.5386L25.0334 6.40516H23.441ZM23.7147 8.35238L24.2795 11.0591H22.7328L23.7147 8.35238ZM13.0238 6.40516L11.4812 13.6133H13.346L14.8878 6.40516H13.0238ZM10.2651 6.40516L8.32411 11.3113L7.53899 7.1397C7.44682 6.67403 7.08302 6.40516 6.67902 6.40516H3.50596L3.46161 6.61443C4.11299 6.7558 4.85307 6.98378 5.30142 7.2277C5.57583 7.37669 5.65413 7.50697 5.74422 7.86107L7.23131 13.6133H9.20208L12.2234 6.40516H10.2651Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26608_76539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04504 7.1639L23.7827 -1.20982L28.9554 12.8362L6.21799 21.21",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCardIcon);
export default __webpack_public_path__ + "static/media/visa-card-icon.6b0107915fb3ce9e2e78034d9f80def7.svg";
export { ForwardRef as ReactComponent };